import {useDismissibleUserSetting} from '../../../../util/hooks/use-dismissible-user-setting';

import {useGetFollowUpTasksEligibility} from './graphql/hooks/use-get-follow-up-tasks-eligibility';

// All-in-one hook to determine if onboarding for ai follow-up tasks should be shown
// User needs to have recent transcriptions, never seen the onboarding, and
// not have the feature enabled from a different path.
export function useShouldShowFollowUpTasksOnboarding(onboardingSettingName: string): {
    shouldShow: boolean;
    markSeen: (() => Promise<any>) | null | undefined;
} {
    // Make sure they haven't seen the onboarding yet
    const {shouldShow: hasNotSeenOnboarding, onDismiss: markSeen} =
        useDismissibleUserSetting(onboardingSettingName);

    // See if they have have the featured enabled, and if not, if they meet
    // the criteria for showing the onboarding (recent transcription)
    const {isAiFollowUpTasksEnabled, hasRecentTranscriptionSummary} =
        useGetFollowUpTasksEligibility();

    // Determine if we should show the onboarding based on above
    const shouldShowModal = getShouldShowModal(
        isAiFollowUpTasksEnabled,
        hasRecentTranscriptionSummary,
        hasNotSeenOnboarding
    );

    return {
        shouldShow: shouldShowModal,
        markSeen,
    };
}

function getShouldShowModal(
    isAiFollowUpTasksEnabled: boolean | null,
    hasRecentTranscriptionSummary: boolean | null,
    hasNotSeenOnboarding: boolean
): boolean {
    // Feature isn't on yet - don't show the modal
    if (!NutClientConfig.hasAiFollowUpTasksFF) {
        return false;
    }

    // Double negative - they HAVE seen the onboarding, so hide it
    if (!hasNotSeenOnboarding) {
        return false;
    }

    // Already enabled the feature, no need for onboarding
    if (isAiFollowUpTasksEnabled) {
        return false;
    }

    // No recent transcription summary, no need for onboarding
    // since they can't use this feature yet
    if (!hasRecentTranscriptionSummary) {
        return false;
    }

    return true;
}
